<rid-sentence-reading-base
  [title]="'Lichtkrant'"
  [sentencesMatrix]="sentencesMatrix()"
  [pace]="pace()"
  [doSentencePass]="doSentencePass.bind(this)"
  (finished)="finished.emit()"
/>
